import { withPageAuthRequired, getSession } from '@auth0/nextjs-auth0'
import { type GetServerSidePropsContext } from 'next'

import { getLoggedUser } from '@flecto-io/core/src/actions'
import { type IUserState } from '@flecto-io/core/src/interfaces'
import { setDefaults } from '@flecto-io/core/src/services'

import { AUTH0_ISSUER_BASE_URL } from '../auth.config'
import { API_URL } from '../auth.config'
import { mountPreloadedState } from '../helpers/mountPreloadedState'

interface IWithUserSessionServer {
  getServerSideProps: (
    context: GetServerSidePropsContext,
    user: IUserState | null,
    auth?: {
      bearerToken: string
      idToken: string
    } | null
  ) => unknown
  requireAuth?: boolean
}

export default function getServerSideProps(
  handleOptions: IWithUserSessionServer
) {
  setDefaults({ baseURL: API_URL })

  return async function serverSideProps(context: GetServerSidePropsContext) {
    try {
      const { req, res } = context

      let user = null as IUserState | null
      const redux = mountPreloadedState()

      if (handleOptions?.requireAuth) {
        // This function changes context response and redirect to Login Out-of-the-Box
        await withPageAuthRequired()(context)
      }

      const session = getSession(req, res)

      if (session?.accessToken && session?.idToken) {
        await redux.dispatch(
          getLoggedUser({
            rejectRequestUserinfo: true,
            auth0IssuerBaseUrl: String(AUTH0_ISSUER_BASE_URL),
            bearerToken: session?.accessToken || '',
            idToken: session?.idToken || '',
          })
        )
      }

      user = redux.getState().user

      const tokens = {
        bearerToken: session?.accessToken || '',
        idToken: session?.idToken || '',
      }

      return handleOptions.getServerSideProps(context, user, tokens)
    } catch {
      return handleOptions.getServerSideProps(context, null, null)
    }
  }
}
